/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';
import { get } from 'lodash';
import { UserProfileContext } from 'src/pagesDashboard/UserProfile/context/UserProfileProvider';
import { useFeedback } from 'src/queries/feedback';
import { useReviews } from 'src/queries/reviews';

export const useUserProfile = ({
  includeEmptyComments = true,
  reportUserId
}) => {
  const { context } = useContext(UserProfileContext);
  const range = context.range.value;

  const {
    range: { start, end }
  } = context;
  const {
    category, reviewerGroup, reviewerIds, roles
  } = context.filters;

  let { userId } = context;
  userId = userId || reportUserId;
  const filters = {
    range,
    start,
    end,
    category,
    includeEmptyComments,
    reviewerIds,
    reviewerGroup,
    roles
  };
  const { profileHistoricReviews } = context;

  const {
    data: { reviews: userReviews, pagination },
    isFetching: isFetchingReviews
  } = useReviews({
    userId,
    filters,
    options: {
      page: profileHistoricReviews.page,
      size: profileHistoricReviews.pageSize
    }
  });

  return {
    pagination,
    userReviews,
    isFetchingReviews
  };
};

export const useUserFeedback = (userId, queryFilters, queryOptions = {}) => {
  const {
    key,
    range: { value: rangeValue, start, end },
    pages,
    viewerId
  } = queryFilters;

  const {
    category,
    reviewerIds,
    reviewerGroup,
    roles,
    includeEmptyComments,
    includeAnonymousReviews,
    includeUnassignedUsers,
    dateKey,
    feedbackStatus,
    reviewerManagerIds,
    revieweeManagerIds,
    requestedBy,
    notRequestedBy
  } = get(queryFilters, 'filters', {});

  const { sortBy, sortOrder } = get(queryFilters, 'sort', {});

  const filters = {
    ids: Array.isArray(userId) ? userId : [userId],
    dateKey,
    range: rangeValue,
    start,
    end,
    category,
    reviewerIds,
    reviewerGroup,
    roles,
    includeEmptyComments,
    includeAnonymousReviews,
    includeUnassignedUsers,
    feedbackStatus,
    reviewerManagerIds,
    revieweeManagerIds,
    requestedBy,
    notRequestedBy
  };

  const options = {
    page: pages?.page,
    size: pages?.pageSize,
    ...(viewerId && { viewerId }),
    ...(sortBy && { sortBy }),
    ...(sortOrder && { sortOrder })
  };

  const {
    data: { feedbacks, pagination },
    isFetching: isFetchingFeedbacks,
    isError: isErrorFeedbacks,
    isRefetching: isRefetchingFeedbacks,
    isPlaceholderData: isPlaceholderDataFeedbacks
  } = useFeedback(
    {
      ...filters,
      options
    },
    {
      ...queryOptions
    }
  );

  return {
    data: {
      pagination,
      userFeedbacks: feedbacks
    },
    isFetching: isFetchingFeedbacks,
    isError: isErrorFeedbacks,
    isRefetching: isRefetchingFeedbacks,
    isPlaceholderData: isPlaceholderDataFeedbacks
  };
};
